import { memo } from 'react';

import { SwitchItemProps } from '@/components/dropdown/types';

const SwitchItem = ({ checked, label }: SwitchItemProps) => (
	<label className="toggle-field">
		<span className="toggle-label">{label}</span>
		<div className="toggle">
			<input type="checkbox" checked={!!checked} readOnly />
			<span className="backdrop" />
			<span className="visual" />
		</div>
	</label>
);

export default memo(SwitchItem);
